module.exports = __webpack_public_path__ + "static/007109-128ac4bf99c04c25064ee8942a7693cb.jpg";